import {
    GET_ORDER_BY_ID,
    SET_ORDER_BY_ID,
    GET_CART_COUNT,
    SET_CART_COUNT,
    SET_CART_ORDERS,
    GET_CART_ORDERS,
    GET_DELETE_CART_ORDER,
    SET_DELETE_CART_ORDER
} from "./OrderType"

const getOrderById = (val : any) => ({
    type: GET_ORDER_BY_ID,
    val
});

const setOrderById = (orderByIdData: any) => ({
    type: SET_ORDER_BY_ID,
    orderByIdData: orderByIdData
});

const getCartCount = (emailId : any) => ({
    type: GET_CART_COUNT,
    emailId
});

const setCartCount = (cartCount: any) => ({
    type: SET_CART_COUNT,
    cartCount: cartCount
});

const getCartOrders = (emailId : any) => ({
    type: GET_CART_ORDERS,
    emailId
});

const setCartOrders = (cartOrders: any) => ({
    type: SET_CART_ORDERS,
    cartOrders: cartOrders
});

const getDeleteCartOrder = (draftOrderId : any) => ({
    type: GET_DELETE_CART_ORDER,
    draftOrderId
});

const setDeleteCartOrder = (cartOrderDelete: any) => ({
    type: SET_DELETE_CART_ORDER,
    cartOrderDelete: cartOrderDelete
});

export {
    getOrderById,
    setOrderById,
    getCartCount,
    setCartCount,
    getCartOrders,
    setCartOrders,
    getDeleteCartOrder,
    setDeleteCartOrder
}
